"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PromisesHelper {
    static timeout(promise, timeoutMs) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                reject(new Error("timed out"));
            }, timeoutMs);
            promise.then(resolve, reject);
        });
    }
    static resolved(value) {
        return new Promise((resolve) => {
            resolve(value);
        });
    }
}
exports.default = PromisesHelper;
